import { motion } from "framer-motion";

const etapas = [
  {
    etapa: "Ser",
    define: "Quién sos como marca y qué territorio ocupás.",
    da: "Criterio: decidir qué decir sin dudar.",
  },
  {
    etapa: "Hacer",
    define: "Cómo eso se ve, se dice y sale al mundo.",
    da: "Sistema: coherencia en cada contacto.",
  },
  {
    etapa: "Tener",
    define: "Reconocimiento, preferencia, negocio.",
    da: "Resultado comercial que se acumula.",
  },
];

const GastonComoTrabajamos = () => {
  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(217 61% 8%), hsl(215 48% 14%))",
      }}
    >
      <div className="container px-4 max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12"
        >
          <span
            className="text-sm font-semibold tracking-[0.25em] uppercase mb-4 block"
            style={{ color: "#5BA3E0" }}
          >
            Cómo trabajamos
          </span>
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] mb-6">
            Desde adentro
            <br />
            <span style={{ color: "#5BA3E0" }}>hacia afuera.</span>
          </h2>
          <p className="text-base md:text-lg text-white/75 max-w-3xl mx-auto leading-relaxed">
            Coressen construye marcas desde adentro hacia afuera. Primero el ser,
            después la marca, siempre en coherencia. No es filosofía: es la única
            secuencia que sostiene una autoridad creíble en el tiempo.
          </p>
        </motion.div>

        {/* Ser / Hacer / Tener */}
        <div className="grid md:grid-cols-3 gap-5 mb-14">
          {etapas.map((e, index) => (
            <motion.div
              key={e.etapa}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: index * 0.12 }}
              className="rounded-2xl p-7 border border-white/10"
              style={{
                background:
                  "linear-gradient(180deg, hsl(220 69% 4%), hsl(217 61% 8%))",
              }}
            >
              <p
                className="font-display text-2xl md:text-3xl font-bold uppercase tracking-wide mb-5"
                style={{ color: "#5BA3E0" }}
              >
                {e.etapa}
              </p>
              <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-2">
                Qué se define
              </p>
              <p className="text-sm md:text-base text-white/85 leading-relaxed mb-6">
                {e.define}
              </p>
              <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-2">
                Qué te da
              </p>
              <p
                className="text-sm md:text-base leading-relaxed font-medium"
                style={{ color: "#4FD1A5" }}
              >
                {e.da}
              </p>
            </motion.div>
          ))}
        </div>

        {/* El 360 empieza por el reino */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="rounded-2xl p-8 md:p-10 border-l-4"
          style={{
            borderColor: "#5BA3E0",
            background: "rgba(91,163,224,0.07)",
          }}
        >
          <h3 className="font-display text-xl md:text-2xl font-semibold text-white mb-4">
            El 360 empieza por el reino
          </h3>
          <p className="text-sm md:text-base text-white/80 leading-relaxed">
            Preguntaste si trabajamos 360 o si tenías que buscar por un lado al
            diseñador y por otro al que publica.
            <br />
            <br />
            Trabajamos 360, pero no se arma el equipo antes de conocer el reino:
            <br />
            Primero entendemos tu territorio, sus prestaciones, el mapa a conquistar y expandir. Recién ahí se
            define la estrategia, y con ella qué equipo necesitás, con qué
            alcances, qué OKRs y KPIs vas a accionar, y qué datos duros vamos a
            medir.
            <br />
            <br />
            Ese equipo se activa después, por etapas y objetivos
            consensuados. Vos no coordinás proveedores sueltos: trabajás con una
            estructura que se arma sobre una estrategia, no sobre una corazonada.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default GastonComoTrabajamos;
